import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDeleteGoal = createAsyncThunk("fetchDeleteGoal", async ({ id }, { rejectWithValue }) => {
	try {
		const token = localStorage.getItem("auth_token");
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				Accept: "application/json",
			},
		};
		const response = await axiosHttp.get(`goal/cancel/${id}`, config);

		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const deleteGoalSlice = createSlice({
	name: "deleteGoalSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
	},

	reducers: {
		resetDeleteGoalState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchDeleteGoal.pending, (state, action) => {
			state.isError = false;
			state.isLoading = true;
		});

		builder.addCase(fetchDeleteGoal.fulfilled, (state, action) => {
			state.isError = false;
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchDeleteGoal.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetDeleteGoalState } = deleteGoalSlice.actions;
export default deleteGoalSlice.reducer;
